import type {
  PickPageProductsQueryResponse,
  PickPageProductsQueryVariables,
} from '~/api/shopify/queries/pickPageProducts.generated';
import type { PickPageProductNodeFragment } from '~/api/shopify/fragments/pickPageProduct.generated';
import type { IPickPageMode, IPickPageSource, IPickPageSourceParams } from '../../types';

import { PickPageProductsDocument } from '~/api/shopify/queries/pickPageProducts.generated';
import { toPickPageItemFromProduct, toProductSearchQuery } from '../../utils';
import { usePickPageConnectionSource } from './usePickPageConnectionSource';
import { PICK_PAGE_PAGE_SIZE, PICK_PAGE_SORT_KEY } from '../../constants';
import { EOrderDirectionType } from '~/core/gemxql/types/order-by';

interface IUsePickPageProductSourceParams extends IPickPageSourceParams {
  sort: EOrderDirectionType;
  /** What the pick is for — the statuses a row may carry depend on it, see `toProductSearchQuery`. */
  mode: IPickPageMode;
  isControl: boolean;
}

export const usePickPageProductSource = ({
  searchValue,
  isEnabled,
  templateAssetKeys,
  sort,
  mode,
  isControl,
}: IUsePickPageProductSourceParams): IPickPageSource =>
  usePickPageConnectionSource<
    PickPageProductsQueryResponse,
    PickPageProductsQueryVariables,
    PickPageProductNodeFragment
  >({
    queryKey: 'pick-page-product-infinity',
    document: PickPageProductsDocument,
    // The only listing whose sort direction the modal offers a toggle for — see `PickPageSort`.
    toVariables: (after?: string) => ({
      first: PICK_PAGE_PAGE_SIZE,
      query: toProductSearchQuery({ searchValue, mode, isControl }),
      sortKey: PICK_PAGE_SORT_KEY,
      reverse: sort === EOrderDirectionType.DESC,
      after,
    }),
    searchValue,
    isEnabled,
    templateAssetKeys,
    toConnection: (response) => response.products,
    toItem: toPickPageItemFromProduct,
  });
